import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  "type": "stop-execution",
  "name": "Stop Execution",
  "category": "utilities",
  "description": "Stops workflow execution immediately - useful for conditional early termination",
  "icon": "StopCircle",
  "color": "red",
  "version": "1.0.0",
  "group": [
    "transform"
  ],
  "defaults": {
    "name": "Stop Execution",
    "color": "#dc2626"
  },
  "inputs": [
    {
      "name": "default",
      "type": "main",
      "displayName": "Input"
    }
  ],
  "outputs": [],
  "tags": [
    "stop",
    "halt",
    "terminate",
    "end",
    "exit",
    "abort"
  ],
  "comingSoon": false
};

export default definition;
